import { useCan } from '../auth/permissions';
import { NAV_ITEMS, type NavItem } from './navigation';

/**
 * Kullanıcının erişebildiği İLK menü hedefi (SEOAI-47 incelemesi).
 *
 * Sabit bir açılış adresi (`/projects`) yanlıştı: yalnızca `role.view` izni olan
 * kullanıcı her girişte erişemediği sayfaya yönlendirilip Forbidden ekranında
 * kalıyordu — üstelik "başa dön" bağlantısı da aynı yere gidip DÖNGÜ yapıyordu.
 *
 * Hedef menüden türetilir: menüde görünen ilk şey neyse açılış da odur. İkisi
 * ayrı ayrı tanımlansaydı biri değiştiğinde diğeri sessizce bayatlardı.
 */
export function useLandingItem(): NavItem | null {
  const can = useCan();

  return NAV_ITEMS.find((item) => item.permission === undefined || can(item.permission)) ?? null;
}
